import { Component, Input } from '@angular/core';

@Component({
  selector: 'mandae-integration-setup-download',
  templateUrl: './integration-setup-download.component.html',
  styleUrls: ['./integration-setup-download.component.scss', '../integration-setup-dialog.shared.scss']
})
export class IntegrationSetupDownloadComponent {

  @Input() download = {
    url: '',
    description: '',
    button: '',
  };
  @Input() stepCount = 0;
  @Input() stepNumber = 0;

}
